var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.box,style:({ paddingBottom: _vm.showBottomNav ? '50px' : '0' })},[(_vm.hasNewgameBannerList && _vm.newGameShow)?_c('NewgameWrapperRecommend',{ref:"newGameBanner",attrs:{"newgameBannerList":_vm.newgameBannerList,"isFirstEnter":_vm.isFirstEnter},on:{"changeSlideType":_vm.changeSlideType,"closeNewgame":function($event){_vm.newGameShow = false}}}):_vm._e(),_c('div',{class:[
      _vm.slideType == 1 ? _vm.$style['box-slide-down'] : '',
      _vm.slideType == 2 ? _vm.$style['box-slide-up'] : '',
    ]},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }